/**
 * Spacing tokens - 4px base unit system
 * Provides consistent spacing throughout the application
 */
export const spacing = {
  // Base scale (4px increments)
  0: '0',
  1: '4px', // 0.25rem
  2: '8px', // 0.5rem
  3: '12px', // 0.75rem
  4: '16px', // 1rem
  5: '20px', // 1.25rem
  6: '24px', // 1.5rem
  8: '32px', // 2rem
  10: '40px', // 2.5rem
  12: '48px', // 3rem
  16: '64px', // 4rem
  20: '80px', // 5rem
  24: '96px', // 6rem

  // Named tokens for semantic use
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  '2xl': '48px',
  '3xl': '64px',
} as const;

export type Spacing = (typeof spacing)[keyof typeof spacing];
